export const GET_ALL_CATEGORIES = "APP/HEADER_PAGE/GET_ALL_CATEGORIES";
export const GET_ALL_CATEGORIES_SUCCESS = "APP/HEADER_PAGE/GET_ALL_CATEGORIES_SUCCESS";
export const GET_ALL_CATEGORIES_FAILURE = "APP/HEADER_PAGE/GET_ALL_CATEGORIES_FAILURE";

export const RESET_TO_INITIAL_STATE = "APP/HEADER_PAGE/RESET_TO_INITIAL_STATE"